var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button", 
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  {
    id: "seq_id",
    label: "Unique Key",
    type: types.INPUT,
  },
  {
    id: "device_control_number",
    label: "機器管理番号",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "computer_name",
    label: "コンピュータ名",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "virtual_environment",
    label: "仮想環境",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "virtual_base_unit",
    label: "仮想基盤の親機",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "equipment_in_charge_department",
    label: "所管部署",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "equipment_in_charge_team",
    label: "所管チーム",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "equipment_in_charge_classification",
    label: "機器所管区分",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "equipment_in_charge_system",
    label: "所管システム",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "leasing_or_rental",
    label: "リース/レンタル",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "manufacture_name",
    label: "メーカ名",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "model_name",
    label: "機種名",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "equipment_classification",
    label: "機器区分",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "cpu_count",
    label: "CPU数",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "remarks",
    label: "備考",
    type: types.TEXT_AREA,
    import: { enabled: true },
  },
  {
    id: "installation_department",
    label: "設置部署",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "installation_team",
    label: "設置チーム",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "installation_base",
    label: "設置拠点",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "floor",
    label: "フロア",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "user_name",
    label: "使用者名（ﾌﾙﾈｰﾑ）",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "registration_date",
    label: "登録日",
    type: types.DATE_PICKER,
  },
  {
    id: "last_update_date",
    label: "最終更新日",
    type: types.DATE_PICKER,
  },
  {
    id: "management_person_name",
    label: "管理担当者名（ﾌﾙﾈｰﾑ）",
    type: types.INPUT,
    import: { enabled: true },
  },

  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_bulk_import.js